import { JianList as JianListComponent } from 'core/components/JianList';

/** 事案一覧全体のコンポーネント。 */
export const JianList = () => {
  return <JianListComponent />;
};
